// ------------------------------------
// Constants
// ------------------------------------

// ------------------------------------
// Actions
// ------------------------------------

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  isMobile: undefined,
};

export default function layoutReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
